module.exports = __webpack_public_path__ + "static/media/gy.f1a8b346.svg";